<template>
  <div class="logo">
    <div :class="$store.state.isMobile ? 'h5Login' : 'pcLogin'">
      <pcLoginWarp :contentType="contentType" ref="pcLoginWarp">
        <!-- 密码登录 -->
        <div slot="inputs" v-if="contentType == 1">
          <div class="inputPhone">
            <el-input v-model="login.mobilePhone" placeHolder="请输入手机号" type="number" clearable  oninput="if(value.length>11)value=value.slice(0,11)"></el-input>
          </div>
          <div class="inputCode inputWidth">
            <el-input v-model="login.passWord" placeHolder="请输入密码" :type="flagType" oninput="if(value.length>16)value=value.slice(0,16)">
              <i slot="suffix" :class="[this.flag?'iconfont el-icon-view':'iconfont el-icon-view eye-close']" @click="getFlag()"></i>
            </el-input>
            <!-- <div @click="resetPassword" class="button1">忘记密码</div> -->
            <div @click="resetPassword" class="button1">修改密码</div>
          </div>
          <div class="authcodeBx">
            <div class="inputCode">
              <el-input v-model="login.authCode" placeHolder="请输入图片验证码" oninput="if(value.length>4)value=value.slice(0,4)"></el-input> 
            </div>
            <img :src="authCode" @click="reloadAuthCode" class="authCode">
          </div>
          <div @click="loginIn" slot="button" :class="$store.state.isMobile ? 'buttonNormal' : 'buttonSumbit'" v-if="contentType == 1">登录</div>
          <div class="textButton textButtons">
            <div @click="toRegister">新用户注册</div>
            <div @click="fastLogin">快捷登录</div>
          </div>
        </div>
        <!-- 快捷登录 -->
        <div v-if="contentType == 4" slot="inputs">
          <div class="inputPhone">
            <el-input v-model="fast.mobilePhone" placeHolder="请输入手机号" type="number" oninput="if(value.length>11)value=value.slice(0,11)" clearable></el-input>
          </div>
          <input type="password" style="display: none">
          <div class="inputCode">
            <el-input v-model="fast.authCode" placeHolder="请输入验证码" type="number" oninput="if(value.length>6)value=value.slice(0,6)"></el-input>
            <div class="button1" @click="getCode('fast')">{{hasCode ? `(${timeNow}s)` : '发送验证码'}}</div>
          </div>
          <div @click="loginIn('fast')" slot="button" :class="$store.state.isMobile ? 'buttonNormal' : 'buttonSumbit'" v-if="contentType == 4">登录</div>
          <div class="textButton textButtons">           
            <div @click="toRegister">新用户注册</div>
            <div @click="fastLogin" style="text-align: right;">密码登录</div>
          </div>
        </div>
        <!-- 重置登录 -->
        <div v-for="n in 3" :key="n" slot="resetIndex" :class="`resetIndex ${n == resetIndex ? 'resetActiveIndex' : ''}`" v-show="false">
          {{n}}
        </div>
        <!-- 第一步 -->
        <div class="title" slot="title" v-show="contentType == 2 && resetIndex == 1" >
          <div class="titleShadow"><span class="titleFont">{{$route.params.resetPassword ? '修改密码' : '修改密码'}}</span></div>
        </div>
        <div v-show="contentType == 2 && resetIndex == 1" slot="inputs">
          <div class="inputPhone">
            <el-input v-model="resetData.phone" placeHolder="请输入手机号" type="number" oninput="if(value.length>11)value=value.slice(0,11);if(this.value!='')" clearable></el-input>
          </div>
          <div class="inputCode">
            <el-input v-model="resetData.verCode" placeHolder="请输入验证码" type="number" auto-complete="new-password" oninput="if(value.length>6)value=value.slice(0,6)"></el-input>
            <div class="button1" @click="getCode('reset')">{{hasCode ? `(${timeNow}s)` : '获取验证码'}}</div>
          </div>
          <div class="inputCode inputPassword">
            <el-input v-model="resetData.password" placeHolder="请输入新密码" :type="flagType" auto-complete="new-password">
              <i slot="suffix" :class="[this.flag?'iconfont el-icon-view':'iconfont el-icon-view eye-close']" @click="getFlag()"></i>
            </el-input>
          </div>
          <div class="passwordTips">密码要求8-16位，必须为字母、数字和特殊字符的组合</div>
          <div class="inputCode inputPassword">
            <el-input v-model="resetData.conPassword" placeHolder="请确认新密码" :type="confirmflagType" auto-complete="new-password">
              <i slot="suffix" :class="[this.confirmflag?'iconfont el-icon-view':'iconfont el-icon-view eye-close']" @click="confirmgetFlag()"></i>
            </el-input>
          </div>
        </div>
        <!-- 第二步 -->
        <div v-show="contentType == 2 && resetIndex == 2" slot="inputs">
          <div class="inputCode">
            <el-input v-model="resetData.password" placeHolder="请输入密码" type="password" auto-complete="new-password"></el-input>
          </div>
          <div class="inputCode">
            <el-input v-model="resetData.conPassword" placeHolder="请确认密码" type="password" auto-complete="new-password"></el-input>
          </div>
        </div>
        <!-- 第三步 -->
        <!-- <div v-show="contentType == 2 && resetIndex == 3" slot="inputs" class="successReset">
          <img src="../../assets/ticket/jxhy_logo.png" class="resetSuccessImg jxhyImg" v-if="$route.query.museumCode == 218425">
          <img src="../../assets/ticket/wbs1.png" class="resetSuccessImg" v-else>
          <div>恭喜您已重置密码，快来登录吧</div>
        </div> -->
         <!-- 重置成功 -->
        <div v-show="contentType == 2 && resetIndex == 2" slot="inputs" class="successReset">
          <img src="../../assets/images/complete.png" :class="$store.state.isMobile?'resetPhoneSuccessImg':'resetSuccessImg'">
          <!--<img v-else src="../../assets/ticket/wbs1.png" class="resetSuccessImg">-->
          <div class="successResetFont">恭喜您已重置密码，快来登录吧</div>
          <div @click="fastLogin" class="buttonSumbit">去登录</div>
        </div>
        <div slot="button"  v-if="contentType == 2 && resetIndex != 2">
          <div class="bottomWarp" :class="$store.state.isMobile ? 'buttonNormal' : 'buttonSumbit'" @click="resetNext">{{resetText}}</div>
          <div class="textButton textButtons">           
            <div></div>
            <div @click="fastLogin" style="text-align: right;" v-if="!$route.params.resetPassword">返回登录页</div>
          </div>
        </div>
      </pcLoginWarp>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import pcLoginWarp from '../../components/ticket/pcLoginWarp.vue'

export default {
  data() {
    return {
      ticketDetail: {},
      statusText: ['停业', '开放', '约满'],
      login: {
        mobilePhone: '',
        authCode: '',
        passWord: ''
      },
      hasCode: false,
      timeNow: 60,
      timeInterval: '',
      authCode: '',
      contentType: 4, //1密码+图片验证码登录 2重置密码 4快捷登录
      resetIndex: 1,
      resetData: {
        phone: '',
        verCode: '',
        password: '',
        conPassword: ''
      },
      fast: {
        mobilePhone: '',
        authCode: ''
      },
      museumCode: '',
      buttonLock: false,
      //密码小眼睛切换
      flag: false,
      flagType: 'password',
      confirmflag: false,
      confirmflagType: 'password',
    };
  },

  components: {pcLoginWarp},

  methods: {
    toRegister() {
      this.$router.push({path: '/ticket/register', query: this.$route.query})
    },

    fastLogin() {
      this.contentType == 1 ? this.contentType = 4 : this.contentType = 1
    },

    resetPassword() {
      this.contentType = 2
      this.resetIndex = 1
      this.$nextTick(() => {
        this.$refs.pcLoginWarp.setErCode()
      })
    },

    toHome() {
      // this.loginIn()
      this.$router.push({path: '/ticket/home', query: this.$route.query})
    },

    getCode(type) {
      let num = type == 'reset' ? this.resetData.phone : ( type == 'fast' ? this.fast.mobilePhone : this.login.mobilePhone )
      if (this.hasCode) return
      if (num.length != 11) return this.$message.error('请输入正确的手机号')
      this.$ajax(`/api/message/send/verification-code?phoneNumber=${num}`).then((res) => {
        this.hasCode = true
        this.timeGo()
      })
    },

    timeGo() {
      this.timeNow = 60
      this.timeInterval = setInterval(() => {
        this.timeNow --
      }, 1000)
    },

    loginIn(type) {
      if (this.buttonLock) return
      this.buttonLock = true
      if (type == 'fast') { //快速登录
        this.fast.museumCode = this.museumCode
        if (!this.fast.authCode) return this.buttonLock = false
        this.$ajax.post('api/auth/jwt/member-token', this.fast).then((res) => {
          if (!res.data) return this.buttonLock = false
          if (this.$cookie.get('token')) {
            this.$cookie.delete('token')
            this.$cookie.delete('ticket_phone')
          }
          //手机号信息保存到store和token里
          this.$store.state.userPhone = this.fast.mobilePhone
          var pat =/(\d{3})\d*(\d{4})/;
          let phone = this.fast.mobilePhone.replace(pat,'$1****$2');
          this.$cookie.set('token', res.data)
          this.$cookie.set('ticket_phone', phone)
          this.loginBack()
          // this.$router.replace({path: '/ticket/home', query: this.$route.query})
          this.buttonLock = false
        }).catch(() => {
          this.buttonLock = false
        })
        return
      }
      // 账户密码登录
      if (isNaN(parseInt(this.museumCode,10))) { //老后台项目
          this.login.museumCode = this.museumCode
          this.$ajax.post('/api/auth/jwt/login', this.login).then((res) => {
          if (!res.data.token) return this.buttonLock = false
          if (this.$cookie.get('token')) {
            this.$cookie.delete('token')
            this.$cookie.delete('ticket_phone')
          }
          //手机号信息保存到store和token里
          this.$store.state.userPhone = this.login.mobilePhone
          var pat =/(\d{3})\d*(\d{4})/;
          let phone = res.data.mobilePhone.replace(pat,'$1****$2');
          this.$cookie.set('token', res.data.token)
          this.$cookie.set('ticket_phone', phone)
          this.loginBack()
          // this.$router.replace({path: '/ticket/home', query: this.$route.query})
          this.buttonLock = false
        }).catch(() => {
          this.buttonLock = false
        })
      } else { //fid的项目
        if (!this.login.mobilePhone || !this.login.passWord || !this.login.authCode) return this.buttonLock = false
        this.login.fid = this.museumCode
        this.$ajax.post('/api/auth/jwt/passport?pic=1', this.login).then((res) => {
          if (!res.rel) return this.buttonLock = false
          if (this.$cookie.get('token')) {
            this.$cookie.delete('token')
            this.$cookie.delete('ticket_phone')
          }
          //手机号信息保存到store和token里
          this.$store.state.userPhone = this.login.mobilePhone
          this.$cookie.set('token', res.data)
          var pat =/(\d{3})\d*(\d{4})/;
          let phone = this.login.mobilePhone.replace(pat,'$1****$2');
          this.$cookie.set('ticket_phone', phone)
          // window.localStorage.setItem('ticket_phone', this.login.mobilePhone)
          this.loginBack()
          // this.$router.replace({path: '/ticket/home', query: this.$route.query})
          this.buttonLock = false
        }).catch(() => {
          this.buttonLock = false
        })
      }
    },

    loginBack() {
      let urlPath = this.$route.params.backOtherPage ? `/ticket/${this.$route.params.backOtherPage}` : '/ticket/home'
      this.$route.params.backOtherPage ? this.$router.replace({path: urlPath, query: this.$route.query}) : this.$router.replace({path: '/ticket/home', query: this.$route.query})
    },

    reloadAuthCode() {
      let code = new Date().getTime()
      window.localStorage.setItem('authCode', code)
      process.env.NODE_ENV == 'development' ? this.getAuthCode() : 
      this.authCode = Glob.baseUrl + `/api/auth/jwt/back-code?t=${code}`
    },

    getAuthCode() {
      const NODE_ENV = process.env.NODE_ENV;
      const baseURL = process.env.NODE_ENV == 'development' ? '' : Glob.baseUrl
      const instance = axios.create({
        baseURL: baseURL
      })
      instance.interceptors.request.use((config) => {
        config.headers.Authorization = this.$cookie.get('token')
        return config
        }, (error) => {
      });
      let date = new Date()
      let code = new Date().getTime()
      window.localStorage.setItem('authCode', code)
      instance(`/api/auth/jwt/back-code?t=${code}`, {responseType: 'blob'}).then((res) => {
        console.log(res)
        this.authCode = window.URL.createObjectURL(res.data)
      })
    },

    resetNext() {
      if (this.resetIndex == 1 && (!this.resetData.phone || !this.resetData.verCode)) {
        return this.$message.error('请填写手机号和验证码')
      }
      return this.submitReset()
    },

    submitReset() {
      if (this.resetData.conPassword != this.resetData.password) return this.$message.error('两次密码不一致，请重试！')
      !isNaN(Number(this.$route.query.museumCode)) ? this.resetData.fid = this.museumCode : this.resetData.museumCode = this.museumCode
      this.$ajax.post('api/auth/jwt/reset', this.resetData).then((res) => {
        // if (!res.rel) {
        //   this.resetIndex = 1
        // }
        this.resetIndex ++
        this.contentType = 2
        this.login = {
          mobilePhone: '',
          authCode: '',
          passWord: ''
        }
      })
    },

    getMuseum() {
      this.$ajax(`/api/admin/front/group/name?museumCode=${this.$route.query.museumCode}`).then((res) => {
        this.$store.state.museumName = res.data
      })
    },

    //密码小眼睛切换状态
    getFlag() {
      this.flag = !this.flag
      this.flagType = this.flag ? 'text' : 'password'
    },
    confirmgetFlag() {
      this.confirmflag = !this.confirmflag
      this.confirmflagType = this.confirmflag ? 'text' : 'password'
    }

  },

  created() {
    window.localStorage.removeItem('authCode')
    this.museumCode = this.$cookie.get('museumCode') || this.$route.query.museumCode
    if (this.$route.query.loginType) this.contentType = this.$route.query.loginType
    this.getMuseum()
  },

  watch: {
    timeNow(val) {
      if (val == 0) {
        clearInterval(this.timeInterval)
        this.hasCode = false
      }
    },

    contentType(val) {
      this.resetData = {
        phone: '',
        verCode: '',
        password: '',
        conPassword: ''
      }
      if (val == 1) {
        this.reloadAuthCode()
      }
    }
  },

  computed: {
    resetText() {
      return this.resetIndex < 3 ? '确定' : '登录'
    },
  }
}
</script>

<style scoped lang="scss">
.logo{
  .logoContent{
    // margin: 8% 0 0 35%;
    margin-left: 30vw;
    padding: 15vh 0 0 5vw;
    height: 85vh;
    width: 63vw;
    position: relative;
    border-radius: 0.2rem;
    background-color: #fff;
    .name{
      font-size: 0.25rem;
      font-weight: 500;
      color: #333;
    }
    .inputPhone, .inputCode{
      width:100%;
      margin:auto;
      position: relative;
    }
    .inputPhone::before{     
      display: inline-block;
      content: '';
      height: 0.26rem;
      width: 0.13rem;
      // background: url('~@/assets/ticket/icon_phone.png') 0 0/100% no-repeat;
      position: absolute;
      top: 0.14rem;
      left: 0.4rem;
      z-index: 222;
      display: none;
    }
    .inputCode::before{
      display: inline-block;
      content: '';
      height: 0.26rem;
      width: 0.13rem;
      // background: url('~@/assets/ticket/icon_password.png') 0 0/100% no-repeat;
      position: absolute;
      top: 0.14rem;
      left: 0.4rem;
      z-index: 222;
      display: none;
    }
    .inputCode img{
      position: absolute;
      top: 0.16rem;
      right: 0.3rem;
      cursor: pointer;
    }
    .authcodeBx{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .authCode{
        width:30%;
        height:.2rem
      }
      .inputCode{
        width:64%;
        margin:0
      }
    }
    .button1{
      position: absolute;
      top: 50%;
      right: 0.08rem;
      border:0;
      padding: 0 0.06rem;
      height: 0.2rem;
      line-height: .2rem;
      margin-top: -0.1rem;
      width: auto;
      &::before{
        content:'';
        position:absolute;
        width:1px;
        height:40%;
        background:#90323D;
        top:30%;
        left:-.02rem
      }
    }
    .successResetFont{
      font-size:.08rem;
      margin-bottom:.2rem
    }
    .buttonSumbit{
      position: relative;
      width: 100%;
      text-align: center;
      height:.26rem;
      // background: #3A5268;
      border-radius: 999px;
      line-height: .26rem;
      font-size: .095rem;
      letter-spacing: 4px;
      margin-top:.12rem;
      // &::after{
      //   background: url('~@/assets/ticket/logo_icon.png') 0 0/100% no-repeat;
      //   height: 0.08rem;
      //   width: 0.16rem;
      //   content: '';
      //   display: inline-block;
      //   position: absolute;
      //   bottom: 0.13rem;
      //   right: 0.1rem;
      // }
    }
    .textButton{
      margin: auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0.1rem;
      margin-top: 0.1rem;
      font-size: 0.12rem;
      font-size: 14px;
      cursor: pointer;
      letter-spacing: 0.01em;
      text-decoration-line: underline;
      color: #3A5268;
      &.newRegister{
        justify-content: center;
        font-size: 0.18rem;
        font-weight: bold;
      }
    }
  }
  .passwordTips{
    font-size:12px;
    line-height: 16px;
    color: rgba(0, 0, 0, 0.2);
    // font-family: STZHONGS;
    text-align: left;
  }
  .resetIndex{
    display: inline-block;
    height: 0.4rem;
    width: 0.4rem;
    color: #fff;
    font-size: 0.2rem;
    border-radius: 50%;
    line-height: 0.4rem;
    background-color: #c5c5c5;
    text-align: center;
    margin:0 .1rem .2rem .1rem;
  }
  
  .resetSuccessImg{
    width: .4rem;
    margin-bottom: 0.15rem;
    margin-top:.2rem;
  }
  .buttonNormal{
    margin: auto;
    margin-top: 0.5rem;
  }
  .eye-close:before{
      background: url('~@/assets/images/eye-close.svg') center/100% 100% no-repeat;
      content:'';
      display:block;
      width:.1rem;
      height:.1rem;
      margin-top:3px
  }

  .h5Login{
    .loginContent{
      .title{
        font-size: 0.6rem;
      }
      .eye-close:before{
          background: url('~@/assets/images/eye-close.svg') center/100% 100% no-repeat;
          content:'';
          display:block;
          width:.4rem;
          height:.4rem;
          margin-top:3px
      }
      .passwordTips{
        font-size:.3rem
      }
    }
    .buttonSumbit, .buttonNormal{
      cursor: unset;
      width:100%;
      height:1.25rem;
      line-height: 1.25rem;
      border-radius:2rem;
      color:#fff;
      font-size:0.47rem;
      margin-top:2rem;
    }
    .inputCode .authCode{
      position: absolute;
      bottom: 0.5rem;
      right: 0.7rem;
      height: 0.8rem;
      // top: 0rem;
    }
    .textButton{
      font-size: 0.4rem;
      text-align: left;
      margin-left: 0.5rem;
      // width: 3rem;
    }
    .textButtons{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin:0;
      margin-top:.4rem;
      color:#6C6C6C;
      font-size:.3rem;
      text-decoration: underline;
    }
    .newRegister{
      // float: right;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 7.7rem;
      margin-left: 0.7rem;
    }
    .resetIndex{
      height: 1rem;
      width: 1rem;
      line-height: 1rem;
      font-size: 0.5rem;
    }
    .inputCode,.inputPhone{
      position: relative;
      margin-bottom:.1rem
    }
    .authcodeBx{
      position:relative;
      .authCode{
        position: absolute;
        right:.2rem;top:50%;
        width:1.9rem;
        height:.8rem;
        margin-top:-.4rem
      }
    }
    .button1{
      height: 100%;
      line-height: 1.2rem;
      right: 0.2rem;
      position: absolute;
      border-radius: 0.6rem;
      padding: 0 0.4rem;
      // color: #90323D;
      font-size: 0.35rem;
      top: 0rem;
      background: none;
      border: 0;
      width:auto;
      padding-right: 0;
      &::before{
        position: absolute;
        content:'';
        width:1px;
        height:.3rem;
        background-color: #90323D;
        left:0;
        top:50%;
        margin-top:-.15rem
      }
    }
    .resetSuccessImg{
      width: 4rem;
    }
    .successReset{
      font-size: 0.4rem;
    }
  }
  
}
</style>
<style type="text/css" lang="scss">
  .successReset{
    display:flex;
    flex-direction: column;
    align-items: center;
  }
  .el-input{display: block !important;}
  .logoContent .el-input__inner{
    width: 100%;
    margin: 8px 0;
    padding: 6px 2px 6px 20px;
    padding-right: 1rem;
    height: 0.26rem;
    border: unset;
    font-size: 14px;
    background: #FFFFFF;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 999px;
    color:#333;
    // font-family: STZHONGS;
  }
  .logo .pcLogin{
    .logoContent .el-input__inner{
      height: 45px;
      padding-right: 120px;
    }
    .logoContent .authcodeBx .el-input__inner{
      padding-right: 0;
    }
    .logoContent{
      .button1{
        right: 12px !important;
        height: 20px;
        line-height: 20px;
        margin-top: -10px;
      }
    }
    .logoContent .buttonSumbit{
      height: 50px;
      line-height: 50px;
      font-size: 18px;
    }
    .eye-close:before{
      width:17px;
      height:17px;
    }
    .inputCode .el-input__suffix{
      right: 100px;
      font-size: 12px;
    }
  }
  .h5Login{
    .logoContent .el-input__inner{
      width: 100%;
      margin: 0.06rem 0;
      padding: 0.05rem .01rem .05rem 0.12rem;
      padding-right: 1rem;
      height: 0.26rem;
      border: unset;
      font-size: 14px;
      background: #FFFFFF;
      border: 1px solid rgba(0, 0, 0, 0.2);
      border-radius: 999px;
      color:#333;
      // font-family: STZHONGS;
    }
  }
  .logoContent .authcodeBx .el-input__inner{
    padding-right:0
  }
  .inputPhone .el-input__suffix{
    background:url(../../assets/images/close.svg) no-repeat center;
    background-size:.1rem .1rem;
    right:.14rem;
  }
  .inputCode .el-input__suffix{
    font-size:.1rem;
    display: flex;
    align-items: center;
    right:.65rem
  }
  .inputPassword .el-input__suffix{
    right:.14rem;
  }
  .inputCode .el-input__suffix .el-input__clear{
    font-size:.1rem
  }
  .inputPhone .el-input__suffix .el-icon-circle-close::before{
    display: none;
  }
  .inputCode .el-input__inner{
    /*width: 2rem;*/
    /*padding-right: ;*/
  }
  .inputCode .el-input__inner:focus,.inputPhone .el-input__inner:focus{
    border: 1px solid rgba(0, 0, 0, 0.2);
  }
  .h5Login .loginContent .title{
    font-size: 0.6rem;
    margin-bottom: 0.3rem;
  }
  .h5Login .inputCode .el-input__suffix{
    right:2.4rem;
    font-size:.38rem
  }
  .h5Login .inputPassword .el-input__suffix{
    right:0.2rem;
  }
  .resetPhoneSuccessImg{
    width: 1.7rem;
    height: 1.7rem;
    margin-bottom: 0.7rem;
    margin-top: 1.5rem;
  }
  .h5Login .inputWidth .el-input input{
    width: 7.5rem;
    padding-right: 3rem;
  }
</style>
